import cloneDeep from 'lodash.clonedeep';
import { connectedStore } from '../../store';
import selectors from '../selectors';

const getBlockSettings = (blockId) => {
  const store = connectedStore.get();
  const state = store.getState();

  const blockSettings = cloneDeep(selectors.getBlockSettings(state, blockId));

  if (!blockSettings) return null;

  return blockSettings;
};

export default getBlockSettings;
